import ProductImage from "../../../../../../shared/ProductImage/ProductImage";

const CardProduct = ({ data }) => {
    return (
        <div className="card-v2 d-flex">
            <div className="default-method-name card-v2-title d-flex ai-flex-end just-content-center">
                <ProductImage src={ data.imageUrl } alt={data.name} />
                { data.variants?.length > 1 &&
                    <div className="card-variant-dots" title={data.variants.map((v) => v.name).join(", ")}>
                        { data.variants.slice(0, 5).map((v) =>
                            <span key={v._id} style={{ backgroundColor: v.color || "#888" }} />
                        )}
                    </div>
                }
                <div className="info-product">
                    <p>{ data.name }</p>
                    <span className="v2-price"> { data.price } ₴</span>
                </div>
            </div>
        </div>
    );
};

export default CardProduct;